import PropTypes from 'prop-types';

import { CLICK_ACTIONS } from './../../constants';

import { NoAvailablePrices } from 'features/noAvailablePrices';

export const HorizontalWidgetPriceBlock = ({
    bookingRefText,
    clickAction,
    color = '#222',
    currencySymbol,
    price,
    priceText,
    url,
    noPricesMsg,
}) => {
    const inlineStyles = { color: color };

    const showNoPricesMessage = !price && noPricesMsg;

    if (showNoPricesMessage) {
        return <NoAvailablePrices message={noPricesMsg} />;
    }

    if (clickAction === CLICK_ACTIONS.LINK) {
        return (
            <a href={url} target="_blank" rel="noopener noreferrer">
                {price ? (
                    <>
                        <div
                            className="ab-desktop-horizontal-widget-price-obr-text"
                            style={inlineStyles}
                        >
                            {priceText}
                        </div>
                        <div
                            className="ab-desktop-horizontal-widget-price-obr-price"
                            style={inlineStyles}
                        >
                            <span>{currencySymbol}</span> {price}
                        </div>
                    </>
                ) : (
                    <div className="ab-no-prices-msg ab-no-prices-msg--horizontal">
                        {noPricesMsg}
                    </div>
                )}

                <div
                    className="ab-desktop-horizontal-widget-booking-ref-text"
                    style={inlineStyles}
                >
                    <span>{bookingRefText}</span>
                </div>
            </a>
        );
    } else {
        return (
            <div>
                {price ? (
                    <>
                        <div
                            className="ab-desktop-horizontal-widget-price-obr-text"
                            style={inlineStyles}
                        >
                            {priceText}
                        </div>
                        <div
                            className="ab-desktop-horizontal-widget-price-obr-price"
                            style={inlineStyles}
                        >
                            <span>{currencySymbol}</span> {price}
                        </div>
                    </>
                ) : (
                    <div className="ab-no-prices-msg ab-no-prices-msg--horizontal">
                        {noPricesMsg}
                    </div>
                )}

                <div
                    className="ab-desktop-horizontal-widget-booking-ref-text"
                    style={inlineStyles}
                >
                    <span>{bookingRefText}</span>
                </div>
            </div>
        );
    }
};

HorizontalWidgetPriceBlock.propTypes = {
    bookingRefText: PropTypes.string,
    clickAction: PropTypes.string,
    color: PropTypes.string,
    currencySymbol: PropTypes.string,
    price: PropTypes.string,
    priceText: PropTypes.string,
    url: PropTypes.string,
    noPricesMsg: PropTypes.string,
};
